import { render, staticRenderFns } from "./SetupPassword.vue?vue&type=template&id=3335d261&scoped=true"
import script from "./SetupPassword.vue?vue&type=script&lang=js"
export * from "./SetupPassword.vue?vue&type=script&lang=js"
import style0 from "./SetupPassword.vue?vue&type=style&index=0&id=3335d261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335d261",
  null
  
)

export default component.exports